import React from "react";

import { DemoTemplateDashboard } from "./DemoTemplateDashboard";

export function DashboardTemplate() {
  return <>{<DemoTemplateDashboard />}</>;
}
